/**
 * Which floor number a new floorplan may have.
 *
 * Floors are numbered from the ground floor, 0, upwards, one plan per floor. The server refuses
 * the rest too; checking here says so while the number is being typed, before anything is
 * uploaded, and names the floor that is already taken.
 */

export type StoreyProblem = 'required' | 'whole' | 'negative' | 'taken';

/** What is wrong with a floor number as typed, or undefined when it can be used. */
export const storeyProblemOf = (value: string, taken: readonly number[]): StoreyProblem | undefined => {
  const trimmed = value.trim();

  if (!trimmed) return 'required';

  const storey = Number(trimmed);

  if (!Number.isInteger(storey)) return 'whole';
  if (storey < 0) return 'negative';
  if (taken.includes(storey)) return 'taken';

  return undefined;
};

/** The lowest floor number not yet taken, starting from the ground floor. */
export const firstFreeStorey = (taken: readonly number[]): number => {
  let storey = 0;
  while (taken.includes(storey)) storey += 1;
  return storey;
};

/** The translation key that explains a problem. */
export const storeyProblemKey = (problem: StoreyProblem): string => `floorplan-storey-${problem}`;
